import { Panel } from "../layout/Panel.tsx";
import { MetricCard } from "../viz/MetricCard.tsx";
import { metrics } from "../../stores/metrics.ts";

export function SprintPanel() {
  const get = (m: string) => metrics.latest[`jira:${m}`]?.value;
  return (
    <Panel title="Sprint · Jira" href="https://tedconferences.atlassian.net/jira/software" span="col-span-4">
      <div class="grid grid-cols-2 gap-3">
        <MetricCard label="Open" value={get("open_issues")} digits={0} />
        <MetricCard label="In Review" value={get("in_review")} digits={0} />
        <MetricCard label="Done This Sprint" value={get("done_sprint")} digits={0} />
        <MetricCard label="Velocity" value={get("velocity_last_sprint")} digits={0} />
      </div>
    </Panel>
  );
}
